import React from 'react';
import { Container } from 'react-bootstrap';
import InputBox from '@/components/InputBox';
import Aivideo from '@/assets/videos/Aivideo.mov';

const HeaderSection = ({ messages, userInput, setUserInput, isRecording, handleSendMessage, handleStartRecording, handleStopRecording, uploadFile }) => {
  return (
    <Container fluid className="flex-grow-1 d-flex flex-column justify-content-between" style={{ padding: '1.5rem' }}>
      <div className="text-center mb-4">
        <video
          src={Aivideo}
          style={{
            width: '120px',
            height: '120px',
            marginBottom: '16px',
            borderRadius: '12px',
            objectFit: 'cover'
          }}
          autoPlay
          loop
          muted
          playsInline
        />
        <h2>Your AI-powered assistant is here.</h2>
        <p className="text-muted">Ask about calls, conversions, and more.</p>
        {messages.length === 0 && (
          <InputBox
            isFixed={false}
            userInput={userInput}
            setUserInput={setUserInput}
            isRecording={isRecording}
            handleSendMessage={handleSendMessage}
            handleStartRecording={handleStartRecording}
            handleStopRecording={handleStopRecording}
            uploadFile={uploadFile}
          />
        )}
      </div>
    </Container>
  );
};

export default HeaderSection;